import Service from '@ember/service';
import { debounce } from '@ember/runloop';

/**
 * A wrapper around timing functions to make testing easier.
 */
export default class Timing extends Service {
  debounce(...args) {
    return debounce(...args);
  }
}